// src/Question.tsx
import React from 'react';
import { QuestionProps } from './types';

const Question: React.FC<QuestionProps> = ({
  question,
  handleAnswerSelect,
  selectedAnswers,
  handleSubmitAnswer,
  isAnswerCorrect,
}) => {
  return (
    <div className="question-section">
      <h2>{question.question}</h2>
      <div className="answer-section">
        {question.options.map((option, index) => (
          <button
            key={index}
            onClick={() => handleAnswerSelect(index)}
            className={
              selectedAnswers.includes(index)
                ? isAnswerCorrect === null
                  ? 'selected-answer'
                  : isAnswerCorrect
                  ? 'correct-answer'
                  : 'incorrect-answer'
                : ''
            }
          >
            {option.answerText}
          </button>
        ))}
      </div>
      {isAnswerCorrect === null && (
        <button onClick={handleSubmitAnswer} className="submit-button">
          Submit Answer
        </button>
      )}
    </div>
  );
};

export default Question;
